import React from 'react';
import { PublicIcon, CMEIcon, EPharmIcon, MemberOnlyIcon } from './Icons';

export const rolePages = [
  {
    value: 'public',
    icon: <PublicIcon />,
    name: 'Public',
  },
  {
    value: 'cme',
    icon: <CMEIcon />,
    name: 'CME',
  },
  {
    value: 'e-pharm',
    icon: <EPharmIcon />,
    name: 'E-Pharm',
  },
  {
    value: 'member-only',
    icon: <MemberOnlyIcon />,
    name: 'Member Only',
  },
];

export const roleMenu = {
  public: [
    { name: 'About Us', link: '/public/about-us' },
    { name: "What's News", link: '/public/news' },
    { name: 'E-Health', link: '/public/e-health' },
    { name: 'Doctors', link: '/public/doctors' },
    { name: 'Hospital', link: '/public/hospital' },
    { name: 'Gallery', link: '/public/gallery' },
    { name: 'Links', link: '/public/links' },
    { name: 'Download', link: '/public/downloads' },
    { name: 'Media Release', link: '/public/media-release' },
  ],
  cme: [
    { name: 'CME Events', link: '/cme/events' },
    { name: 'CME Quizzes', link: '/cme/quizzes' },
    { name: 'CME Video', link: '/cme/videos' },
    { name: 'Event Organizers', link: '/cme/event-organizers' },
    { name: 'Useful Links', link: '/cme/links' },
    { name: 'Guidelines', link: '/cme/guidelines' },
  ],
  'e-pharm': [
    { name: 'Drug News', link: '/e-pharm/drug-news' },
    { name: 'New Drugs', link: '/e-pharm/new-drugs' },
    { name: 'Drug Search', link: '/e-pharm/drug-search' },
    { name: 'Tools', link: '/e-pharm/tools' },
    { name: 'Events', link: '/e-pharm/events' },
    { name: 'Special Offers', link: '/e-pharm/special-offers' },
    { name: 'External Links', link: '/e-pharm/links' },
    { name: 'Pharm Dir', link: '/e-pharm/pharm-dir' },
  ],
  'member-only': [
    { name: 'News', link: '/member-only/news' },
    { name: 'HKDU Events', link: '/member-only/events' },
    { name: 'Union Album', link: '/member-only/album' },
    { name: 'Knowledge Materials', link: '/member-only/knowledge-materials' },
    { name: 'Members', link: '/member-only/members' },
    { name: 'Tools', link: '/member-only/tools' },
  ],
};
